(ns frontend.ux-overhaul.listing.fund.event
  (:require [frontend.ux-overhaul.listing.generic.bulk-actions :as bulk-actions]
            [frontend.view.entity :as entity]
            [re-frame.core :as rf]))

(rf/reg-event-fx
 ::create-fund
 (fn [_ _]
   (entity/open-creator! :entity.type/fund {})
   {}))

(rf/reg-event-fx
 ::open-bulk-edit
 (fn [_ [_ {:keys [listing-id]}]]
   (rf/dispatch [::bulk-actions/open-bulk-edit {:listing-id listing-id}])
   {}))

(rf/reg-event-fx
 ::bulk-delete-selected
 (fn [{:keys [db]} [_ {:keys [listing-id]}]]
   ;; Legacy funds_grid caps delete at 1 fund at a time (cascade risk to
   ;; commitments/holdings) - the new engine has no reactive per-selection
   ;; :enabled? yet, so the cap is enforced inside the handler instead of by
   ;; disabling the button ahead of time (see ai/mistakes.md).
   (bulk-actions/bulk-delete-selected!
    {:db        db
     :listing-id listing-id
     :operation :fund/mass-action
     :max-count 1
     :body-fn   (fn [ids]
                  {:action   :delete-funds
                   :fund-ids ids})})
   {}))

(rf/reg-event-fx
 ::export-grid
 (fn [_ [_ {:keys [listing-id]}]]
   (bulk-actions/export-grid! {:listing-id  listing-id
                               :entity-type :entity.type/fund})
   {}))

(rf/reg-event-fx
 ::export-grid-with-persons
 (fn [_ [_ {:keys [listing-id]}]]
   (bulk-actions/export-grid! {:listing-id                   listing-id
                               :entity-type                  :entity.type/fund
                               :include-associated-persons? true})
   {}))
